// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#resident-detail[data-v-ca1894ea]{max-width:1280px;margin-left:auto;margin-right:auto}#resident-detail .box-header .title[data-v-ca1894ea]{font-size:22px;font-weight:700}#resident-detail .box-header .spinner[data-v-ca1894ea]{width:22px;height:22px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
